<template>
  <div class="batch">
     <div class="header">
        <el-button class="ml20" size="mini" :loading="loading" type="primary" @click="handleRecognitionClick">识别剪切板</el-button>
        <el-link class="ml20" type="primary" @click="openTemplate">点击(查看/使用)模板</el-link>
        <span class="tip ml20">按照模板填写内容后进行复制，复制后在此处点击【识别剪贴板】</span>
     </div>
        <el-table
            stripe
            :data="tableData"
            :header-cell-style="{ background: '#e8eaec', color: '#333' }"
            max-height="600px"
        >
            <el-table-column
                type="index"
                label="序号"
                width="50"/>
            <el-table-column
                width="180"
                :prop="item.name"
                v-for="(item, index) in column"
                :key="index">
            >
                <template v-slot:header>
                    {{item.display_name}}
                    <el-tooltip v-if="item.name === 'customer_id'"  effect="dark" content="多个客户可用中、英文逗号分隔" placement="top">
                        <i class="el-icon-question"></i>
                    </el-tooltip>
                </template>
                <template slot-scope="scope">
                    <span>{{scope.row[item.name]}}</span>
                </template>

            </el-table-column>
        </el-table>
  </div>
</template>

<script>
import { getClipboard } from '@/utils'
import { getAppEntryCustomerListApi, getAppEntryGetFiled, appEntryBatchAddApi } from '@/api'
import { flattenDeep, uniqBy } from 'lodash'
import { errDataTipModal } from '../';
const regSplit = /,|，/g;
export default {
    name: 'BatchAdd',
    props: ['dict',  'package'],
    data() {
        return {
            tableData: [
                // {
                    
                //     "customer_id": "广州声动网络科技有限公司，广州悦道信息科技有限公司",
                //     "plat_id": "vivo",
                //     "app_type": "游戏",
                //     "package_type": "安卓应用",
                //     "game_classify": "IAA",
                //     "subproject_name": "模拟校园生活",
                //     "subproject_id": "",
                //     "subproject_content": "com.monixysh.vivo"
                // },
                // {
                    
                //     "customer_id": "广州声动网络科技有限公司，广州悦道信息科技有限公司",
                //     "plat_id": "vivo",
                //     "app_type": "游戏",
                //     "package_type": "安卓应用",
                //     "game_classify": "IAA",
                //     "subproject_name": "模拟校园生活",
                //     "subproject_id": "",
                //     "subproject_content": "com.monixysh.vivo"
                // },
                // {
                //     "customer_id": "北京神州泰奇互动科技有限公司，重庆易宠科技有限公司",
                //     "plat_id": "OPPO111",
                //     "app_type": "游戏",
                //     "package_type": "安卓应用",
                //     "game_classify": "IAA",
                //     "subproject_name": "模拟校园生活",
                //     "subproject_id": "",
                //     "subprojet_content": "com.monixysh.vivo"
                // },
                // {
                //     "customer_id": "北京神州泰奇互动科技有限公司",
                //     "plat_id": "OPPO111",
                //     "app_type": "游戏",
                //     "package_type": "安卓应用",
                //     "game_classify": "IAA",
                //     "subproject_name": "模拟校园生活",
                //     "subproject_id": "",
                //     "subprojet_content": "com.monixysh.vivo"
                // }
            ],
            colNum: 8, 
            loading: false,
            column:[
                {
                    "name": "customer_id",
                    "display_name": "绑定客户"
                },
                {
                    "name": "plat_id",
                    "display_name": "媒体"
                },
                {
                    "name": "app_type",
                    "display_name": "产品类型"
                },
                {
                    "name": "package_type",
                    "display_name": "包体类型"
                },
                {
                    "name": "game_classify",
                    "display_name": "游戏分类"
                },
                {
                    "name": "subproject_name",
                    "display_name": "名称"
                },
                {
                    "name": "subproject_id",
                    "display_name": "ID"
                },
                {
                    "name": "subproject_content",
                    "display_name": "包名"
                },
                {
                    "name": "test_field",
                    "display_name": "测试字段"
                }
            ],
            submitData: []
        }
    },
    computed: {
    },
    activated() {
        this.getTableColumn()
    },
    methods: {
        async getFormData() {
            let new_table = this.tableItemNameToId()
            const params = {
                add_type: 2,
                app_info: new_table
            };
            // if(!new_table || new_table.length === 0) {
            //     this.$message.error('请重新复制新的数据。')
            //     return Promise.reject()
            // }
            // try {
            //     await appEntryBatchAddApi(params)
            // } catch (error) {
            //     if(error.remove) {
            //         const { vm } = errDataTipModal({
            //             width: '400px',
            //             props: {
            //                 list: error.data.map(v=> {
            //                     return {
            //                         tip: v.error_msg,
            //                         error_num: v.error_num
            //                     }
            //                 }),
            //                 remove: true,
            //                 hasNum: true
            //             },
            //             cbs: {
            //                 onSubmit: () => {
            //                     vm.close()
            //                     let del_index_list = error.data.reduce((prev, cur)=>{
            //                         prev.push(...cur.error_num)
            //                         return prev
            //                     }, [])
            //                     let uniq_index_list = uniqBy(del_index_list)
            //                     this.tableData = this.tableData.filter((v, i)=> !uniq_index_list.includes(i+1))
            //                 }
            //             }
            //         })
            //         return Promise.reject()
            //     }else{
            //         return this.tableItemNameToId()
            //     }
                
            // }

            return this.tableItemNameToId()
        },
        validateTableData(validate, item, index, customerObj) {
            const [ 
                customerName, platName,  appTypeName, packageTypeName, gameTypeName, nameMame, idName, contentName
            ] = Object.values(item);
            const data = {
                subproject_name: nameMame,
                subproject_id: idName,
                subproject_content: contentName,
            };
            // 产品名称
            customerName.split(regSplit).map(customerName=> {
                if (!customerObj[customerName]) {
                    validate.COL_1.err.index.push(index)
                } else if(!customerName) {
                    validate.COL_1.empty.index.push(index)
                }else {
                    if (data.customer_id) {
                        data.customer_id.push(customerObj[customerName])
                    }else {
                        data.customer_id = [customerObj[customerName]]
                    }
                    
                }
            });
            data.customer_id = this.dedArr(data.customer_id||[])
            // 媒体
            let platId = '';
            const plat = this.dictPlatObj
            if ( !platName) {
               validate.COL_2.empty.index.push(index)
            } else if(!plat[platName]) {
                validate.COL_2.err.index.push(index)
                validate.COL_2.err.list.push(platName)
            }else {
                const [ plat_id, id ] = plat[platName]
                data.plat_id = plat_id;
                platId = id;
            }
            // 产品类型
            const appType = this.appTypeObj
            if (!appTypeName) {
                validate.COL_3.empty.index.push(index)
            } else if(!appType[appTypeName]) {
               validate.COL_3.err.index.push(index)
               validate.COL_3.err.list.push(appTypeName)
            }else {
                data.app_type = appType[appTypeName]
            }
            // 包体类型
            const packageList = this.dictPackageTypeNmeList;
            const packageObj = platId? this.dictPackageObj(platId) :{}
            if(!packageTypeName) {
                validate.COL_4.empty.index.push(index)
            }else if (!packageList.includes(packageTypeName)) {
                validate.COL_4.err.index.push(index)
                validate.COL_4.err.list.push(packageTypeName)
            }  else if(platId) {
                if (!Object.keys(packageObj).includes(packageTypeName)) {
                    validate.COL_4.level.index.push(index)
                    validate.COL_4.level.list.push(packageTypeName)
                }else {
                    data.package_type = packageObj[packageTypeName]
                }
            }
            // 游戏分类
            const gameType = this.gameTypeObj;
            if (appTypeName ==='游戏') {
                if(!gameTypeName) {
                    validate.COL_5.empty.index.push(index)
                }else if (!Object.keys(gameType).includes(gameTypeName)) {
                    validate.COL_5.err.index.push(index)
                    validate.COL_5.err.list.push(gameTypeName)
                }  else if(appTypeName !=='游戏'&&gameTypeName) {
                    validate.COL_5.level.index.push(index)
                }else {
                    data.game_classify = gameType[gameTypeName]
                }
            }
            return data;
        },
        tableItemNameToId() {
            let getNoTextList = this.column.filter(item=>item.field_type !== 'text' && item.field_type !== 'multiselect').map(item=>item.name)
            
            let res_list = this.tableData.map((item, index, arr) => {
                let res = {}
                for (const [key, value] of Object.entries(item)) {
                    if(getNoTextList.includes(key)) {
                        let fliter_result = this.package[key] ? this.package[key].filter(ele=>ele.name === value) : null
                        let id = ''
                        if(key == 'plat_id') {
                            id = fliter_result && fliter_result.length !== 0 ? fliter_result[0].id : item['plat_id']
                        }else{
                            id = fliter_result && fliter_result.length !== 0 ? fliter_result[0].id : null
                        }
                        
                        res[key] = id
                    }
                }
                return {...item, ...res}
            })
            let result = res_list.map(item=>{
                let customer_list = item['customer_id'] && item['customer_id'].split('，')
                let plat_id__list= this.package['plat_id'].filter(ele=>ele.id == item['plat_id'])
                let plat_id__list_status = plat_id__list && plat_id__list.length !== 0 ? plat_id__list[0]['docking_status'] : null
                
                if(plat_id__list_status === undefined) {
                    console.log('no status')
                }else{
                    item['customer_id'] = customer_list && customer_list.map(ele_customer=>{
                        let customer_key = `docking_status_${plat_id__list_status}`
                        let fliter_result_customer = this.package[customer_key] ? this.package[customer_key].filter(ele=>ele.name === ele_customer) : null
                        let id = fliter_result_customer && fliter_result_customer.length !== 0 ? fliter_result_customer[0].id : ele_customer
                        return id
                    })
                }
                return {...item}
            })
            return result
        },
        // 列表
        async getTableColumn() {
            const { data } = await getAppEntryGetFiled({type: 'batch'});
            this.column = data
        },
        async handleRecognitionClick() {
            try {
                this.loading = true
                const text = await getClipboard();
                const list = text.split('\n').map(v=> {
                    let current_table_keys = this.column.map(item=>item.name)
                    return v.split('\t').reduce((pre, item, index)=> {
                        if(current_table_keys.length >= index) {
                            let cur_key = current_table_keys[index]
                            pre[cur_key] = item.replace(/\r/g, '')
                        }else{
                            pre[`${col_}${index+1}`] = item.replace(/\r/g, '')
                        }
                        return pre;
                    }, {})
                }).filter(v=> {
                    return !!Object.values(v).join('')
                });
                if (list.length) {
                    this.tableData = list;
                    this.$message.success('识别成功')
                }else {
                   this.$message.error('未获取到剪贴板内容或获取的内容为空，请重新复制')
                }
            } catch (error) {
                this.$message.error(error.message)
            } finally {
                this.loading = false
            }
        },
        openTemplate() {
            window.open('https://docs.qq.com/sheet/DVXNlaUtNUkxxRU1K?tab=BB08J2')
        },
        dedArr(list) {
            return [...new Set(list)]
        },
        /**
         * 数组对象 指定属性是否重复 收集重复的数组
         *
         * */
        findDuplicateArrays(arr) {
            let seenCombinations = new Map();
            let duplicates = [];

            arr.forEach((obj, index) => {
                let combination = obj['subproject_name'];

                if (seenCombinations.has(combination)) {
                    duplicates.push({
                        index: index,
                        tips: combination
                    });
                } else {
                    seenCombinations.set(combination, index);
                }
            });

            return duplicates;
        },
        filterList(delIds) {
            console.log('delIds', delIds)
            this.tableData = this.tableData.filter((v, i)=> !delIds.includes(i+1))
            console.log('this.tableData', this.tableData)
            this.tableItemNameToId()
        }
    }
}
</script>

<style lang="scss" scoped>

.header {
    position: absolute;
    right: 0;
    top: 2px;
    .tip {
        font-size: 12px;
    }
}
</style>